import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { amlbotAPI } from '@/api';
import type {
  AddressMonitoringListRequest,
  AddressMonitoringListResponse,
  MonitoringUnsubscribeRequest,
  MonitoringUnsubscribeResponse,
} from '@/api';
import { parseError } from '@/redux/helpers';
import { addressMonitoringActions } from '@/redux/actions';
import { addressMonitoringMappers } from '@/redux/mappers';

function* fetchMonitoringList(
  action: PayloadAction<AddressMonitoringListRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: AddressMonitoringListResponse = yield call(
      amlbotAPI.fetchMonitoringList,
      payload,
    );
    const data = addressMonitoringMappers.monitoringHistory(response);
    const isShowMoreRequest = 'page' in payload;

    if (isShowMoreRequest) {
      yield put(addressMonitoringActions.addData(data));
    } else {
      yield put(addressMonitoringActions.setData(data));
    }
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(addressMonitoringActions.setError(message));
  } finally {
    yield put(addressMonitoringActions.setLoading(false));
  }
}

function* monitoringUnsubscribe(
  action: PayloadAction<MonitoringUnsubscribeRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: MonitoringUnsubscribeResponse = yield call(
      amlbotAPI.monitoringUnsubscribe,
      payload,
    );
    const item = addressMonitoringMappers.addressItem(response.data.data);
    yield put(addressMonitoringActions.refreshDataItem(item));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(addressMonitoringActions.setError(message));
  } finally {
    yield put(addressMonitoringActions.setLoading(false));
  }
}

export { fetchMonitoringList, monitoringUnsubscribe };
